export const CLASSIC = 'CLASSIC';
export const DOCKED = 'DOCKED';